export default __webpack_public_path__ + "static/media/Lovkash_garg-preview.25fd8495.png";